import _get from 'lodash.get';
import React, { PureComponent } from 'react';
import { Title } from '../../article/article.component';
import { Article, Media, Sections, Spacer100, Spacer200 } from '../../index';

class Job extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { data } = this.props;
    return (

      <Article>
        <Spacer200 />
        <Title>
          <h2>{_get(data, 'page.title', '')}</h2>
          <p>{_get(data, 'page.intro', '')}</p>
        </Title>
        <Spacer100 />
        <Media image={_get(data, 'page.image', '')}></Media>
        <Spacer100 />

        <Sections {...this.props} />
      </Article>
    );
  }
}

export default Job;
